import { defineAsyncComponent } from 'vue';
const ConfirmDialog = defineAsyncComponent(() => import('@/components/dialog_popup/ConfirmDialog.vue'));

const PromptDialog = defineAsyncComponent(() => import('@/components/dialog_popup/PromptDialog.vue'));

const ResetPassword = defineAsyncComponent(() => import('@/components/dialog_popup/ResetPassword.vue'));

const Register = defineAsyncComponent(() => import('@/components/dialog_popup/Register.vue'));

const Update = defineAsyncComponent(() => import('@/components/dialog_popup/Update.vue'));

const HistoryPanel = defineAsyncComponent(() =>
  //  import('@/components/common/HistoryPanel.vue')
  import('@/components/common/licenseinfo/LicenseInfo.vue')
);

const UpdateAccount = defineAsyncComponent(() => import('@/pages/UpdateAccount.vue'));

const UpdatePartner = defineAsyncComponent(() => import('@/pages/PartnerDetail.vue'));

const RequestDiscount = defineAsyncComponent(() => import('@/components/dialog_popup/RequestDiscount.vue'));

const RequestLicenseInfo = defineAsyncComponent(() => import('@/components/dialog_popup/LicenseInfo.vue'));

const CreateLicenseSummary = defineAsyncComponent(() => import('@/components/dialog_popup/CreateLicenseSummary.vue'));

const UpgradeBranch = defineAsyncComponent(() => import('@/components/dialog_popup/UpgradeBranch.vue'));

const ExtendBranch = defineAsyncComponent(() => import('@/components/dialog_popup/ExtendBranch.vue'));

const SaveFilterTemplate = defineAsyncComponent(() => import('@/components/dialog_popup/SaveFilterTemplate.vue'));

const TwoFactorAuth = defineAsyncComponent(() => import('@/components/dialog_popup/TwoFactorAuth.vue'));

const TwoFactorAuthSuccess = defineAsyncComponent(() => import('@/components/dialog_popup/TwoFactorAuthSuccess.vue'));

const TwoFactorAuthInfo = defineAsyncComponent(() => import('@/components/dialog_popup/TwoFactorInfo.vue'));

const EnterPassword = defineAsyncComponent(() => import('@/components/dialog_popup/EnterPassword.vue'));

const DateFormat = defineAsyncComponent(() => import('@/components/dialog_popup/DateFormatPopup.vue'));

const RemoteDeviceInfo = defineAsyncComponent(() =>
  import('@/components/dialog_popup/RemoteDeviceInfoDialog.vue')
);
export function registerCommonPopup(app) {
  app.component('ConfirmDialog', ConfirmDialog);
  app.component('PromptDialog', PromptDialog);
  app.component('ResetPassword', ResetPassword);
  app.component('Register', Register);
  app.component('Update', Update);
  app.component('HistoryPanel', HistoryPanel);
  app.component('UpdateAccount', UpdateAccount);
  app.component('UpdatePartner', UpdatePartner);
  app.component('RequestDiscount', RequestDiscount);
  app.component('RequestLicenseInfo', RequestLicenseInfo);
  app.component('CreateLicenseSummary', CreateLicenseSummary);
  app.component('UpgradeBranch', UpgradeBranch);
  app.component('ExtendBranch', ExtendBranch);
  app.component('SaveFilterTemplate', SaveFilterTemplate);
  app.component('TwoFactorAuth', TwoFactorAuth);
  app.component('TwoFactorAuthSuccess', TwoFactorAuthSuccess);
  app.component('TwoFactorAuthInfo', TwoFactorAuthInfo);
  app.component('EnterPassword', EnterPassword);
  app.component('DateFormat', DateFormat);
  app.component('RemoteDeviceInfo', RemoteDeviceInfo);
}
